import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import MobileBottomNav from "@/components/feature/MobileBottomNav";

declare const __BASE_PATH__: string;

export default function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
      <MobileBottomNav />
    </BrowserRouter>
  );
}
